import { useWatch } from "react-hook-form";
import { useMemo } from "react";
import {
  buttonSettings,
  CustomizableComponentConfiguration,
  commonSettings,
  fontSettings,
} from "../../../CustomComponents";

export function useSharedJamezzStylesConfiguration(): CustomizableComponentConfiguration {
  const shoppingCartButtonType = useWatch({
    name: "extra_settings__type_of_shopping_cart_button",
  });

  const useAccountServer = useWatch({ name: "useAccountServer" });
  const useAccountServer_input = useWatch({ name: "useAccountServer_input" });

  return useMemo(() => {
    let components: CustomizableComponentConfiguration = [];

    switch (shoppingCartButtonType) {
      case "SMALL":
        components = components.concat(
          {
            className: ".JS-SmallShoppingCartButton-InnerWrapper",
            label: "Small shopping cart",
            values: { backgroundColor: null },
          },
          {
            className: ".JS-SmallShoppingCartButton-Price",
            label: "Small shopping cart total",
            values: { color: null },
          },
          {
            className: ".JS-SmallShoppingCartButton-Count",
            label: "Small shopping cart count",
            values: { color: null },
          }
        );
        break;
    }

    if (Boolean(useAccountServer) && Boolean(useAccountServer_input)) {
      components = components.concat([
        {
          className: ".JS-AccountDiscount-Dialog-Root",
          label: "Dialog for account discount",
          values: {
            backgroundColor: null,
          },
        },
        {
          className: ".JS-AccountDiscount-Dialog-Title",
          label: "Title for the account discount dialog",
          values: {
            color: null,
            fontFamily: null,
            fontSize: null,
            fontWeight: null,
            margin: null,
            padding: null,
          },
        },
        {
          className: ".JS-AccountDiscount-Dialog-Input",
          label: "Inputs (ID/code and lastname) for the account discount dialog",
          values: {
            color: null,
            backgroundColor: null,
          },
        },
        {
          className: ".JS-AccountDiscount-Dialog-InputLabel",
          label: "Label (input description) for the inputs (ID/code and lastname) for the account",
          values: {
            color: null,
          },
        },
        {
          className: ".JS-AccountDiscount-Dialog-Cancel",
          label: "Cancel button for the account discount dialog",
          values: {
            width: null,
            height: null,
            backgroundColor: null,
            fontFamily: null,
            fontSize: null,
            fontWeight: null,
          },
        },
        {
          className: ".JS-AccountDiscount-Dialog-Login",
          label: "Login button for the account discount dialog",
          values: {
            width: null,
            height: null,
            backgroundColor: null,
            fontFamily: null,
            fontSize: null,
            fontWeight: null,
          },
        },
      ]);
    }

    components = components.concat([
      {
        className: ".JS-TopBar-AllergyIcon",
        label: "The icon to select allergies",
        values: { color: null },
      },
      {
        className: ".JS-ArticleSuggestionPage-NoThanksButton",
        label: "No thanks button on upsell page",
        values: {
          width: null,
          height: null,
          ...commonSettings,
        },
      },
      {
        className: ".JS-ArticleSuggestionItem-ViewButton",
        label: "View suggestion button on upsell page",
        values: {
          width: null,
          height: null,
          ...commonSettings,
        },
      },
      {
        className: ".JS-MenuTag-Allergen",
        label: "All allergen icons",
        values: {
          color: null,
          zoom: null,
        },
      },
      {
        className: ".JS-CheckoutPage-CheckoutMessage",
        label: "The customizable message shown at checkout",
        values: {
          color: null,
          backgroundColor: null,
          borderRadius: null,
        },
      },
      {
        className: ".JS-CustomFields-Explanation",
        label: "The text for the 'explanation' customfield property",
        values: {
          ...fontSettings,
        },
      },
      {
        className: ".JS-CustomFieldNumpadContent-Input",
        label: "Custom field input for numeric content (tafelnr, ...)",
        values: {
          color: null,
          backgroundColor: null,
        },
      },
      {
        className: ".JS-CustomFieldNumpadContent-Label",
        label: "Custom field input text for numeric content (tafelnr, ...)",
        values: {
          color: null,
          backgroundColor: null,
        },
      },
      {
        className: ".JS-Tip-Title",
        label: "Title for the tip menu",
        values: {
          color: null,
        },
      },
      {
        className: ".JS-Tip-Custom-Cancel_Button",
        label: "Cancel button in the custom tip menu",
        values: {
          color: null,
          backgroundColor: null,
          border: null,
          borderColor: null,
          borderRadius: null,
        },
      },
      {
        className: ".JS-Tip-Custom_Button",
        label: "Custom tip button",
        values: {
          color: null,
          backgroundColor: null,
          border: null,
          borderColor: null,
          borderRadius: null,
        },
      },
      {
        className: ".JS-Tip-Confirm-Button",
        label: "Confirm tip button",
        values: {
          color: null,
          backgroundColor: null,
          border: null,
          borderColor: null,
          borderRadius: null,
        },
      },
      {
        className: ".JS-Tip-Dont-Tip-Button",
        label: "Don't tip button",
        values: {
          color: null,
          backgroundColor: null,
          border: null,
          borderColor: null,
          borderRadius: null,
        },
      },
      {
        className: ".JS-Tip-Percentage-Button",
        label: "Percentage tip button",
        values: {
          color: null,
          backgroundColor: null,
          border: null,
          borderColor: null,
          borderRadius: null,
        },
      },
      {
        className: ".JS-Search-Root",
        label: "Search Input Root",
        values: {
          color: null,
          backgroundColor: null,
          display: null,
          boxShadow: null,
          border: null,
          borderColor: null,
          borderRadius: null,
          padding: null,
          width: null,
          height: null,
        },
      },
      {
        className: ".JS-Search-Input",
        label: "Search Input Text",
        values: {
          color: null,
          fontSize: null,
          fontFamily: null,
          fontWeight: null,
        },
      },
      {
        className: ".JS-Search-IconClose",
        label: "Search Icon Close",
        values: {
          color: null,
          backgroundColor: null,
        },
      },
      {
        className: ".JS-Search-Icon",
        label: "Search Icon",
        values: {
          color: null,
          backgroundColor: null,
        },
      },
      {
        className: ".JS-CheckoutPage-Extra-Drinks-Button",
        label: "Search Icon",
        values: {
          color: null,
          backgroundColor: null,
          border: null,
          borderRadius: null,
          borderColor: null,
          width: null,
          height: null,
          padding: null,
        },
      },
      {
        className: ".JS-CustomFieldButtonGroupContent-Root",
        label: "Custom fields buttons (payment, takeaway/eat-in, ...) container",
        values: {
          backgroundColor: null,
        },
      },
      {
        className: ".JS-CustomFieldNumpadContent-Wrapper",
        label: "CustomField Numpad Wrapper",
        values: {
          margin: null,
          padding: null,
          width: null,
          height: null,
        },
      },
      {
        className: ".JS-CustomFieldButtonGroupContent-Button",
        label: "CustomField Payment Button",
        values: {
          borderColor: null,
          borderRadius: null,
          backgroundColor: null,
          color: null,
          fontWeight: null,
          fontStyle: null,
          fontFamily: null,
          fontSize: null,
          margin: null,
          padding: null,
          width: null,
          height: null,
        },
      },
      {
        className: ".JS-CustomFieldButtonGroupContent-Button-Selected",
        label: "CustomField Payment Button Selected",
        values: {
          borderColor: null,
          borderRadius: null,
          backgroundColor: null,
          color: null,
          fontWeight: null,
          fontStyle: null,
          fontFamily: null,
          fontSize: null,
          margin: null,
          padding: null,
          width: null,
          height: null,
        },
      },
      {
        className: ".JS-CustomFieldButtonGroupContent-Button-Unselected",
        label: "CustomField Payment Button Not Selected",
        values: {
          borderColor: null,
          borderRadius: null,
          backgroundColor: null,
          color: null,
          fontWeight: null,
          fontStyle: null,
          fontFamily: null,
          fontSize: null,
          margin: null,
          padding: null,
          width: null,
          height: null,
        },
      },
      {
        className: ".JS-CustomFieldButtonGroupContent-Button-Label",
        label: "Custom fields payment button label",
        values: {
          ...fontSettings,
        },
      },
      {
        className: ".JS-CustomFieldDateTimeContent-Label",
        label: "The label (description) for the date time custom field",
        values: {
          color: null,
        },
      },
      {
        className: ".JS-CustomFieldDateContent-Option",
        label: "An option (the items in the dropdown) for the date time custom field",
        values: {
          color: null,
        },
      },
      {
        className: ".JS-CustomField-DateTime-Input",
        label: "The date time component",
        values: {
          backgroundColor: null,
        },
      },
      {
        className: ".JS-CustomFields-Input",
        label: "An input element (text, email and numeric) for the customfields page",
        values: {
          color: null,
          backgroundColor: null,
        },
      },
      {
        className: ".JS-CustomFields-Input-Label",
        label: "The helper text for an input element (text, email and numeric) for the customfields page",
        values: {
          color: null,
        },
      },
      {
        className: ".JS-CustomFieldsEmailContent-Label",
        label: "Label (description) for the e-mail customfield",
        values: { color: null },
      },
      {
        className: ".JS-CustomFieldTextContent-Input",
        label: "The 'text' custom field",
        values: { color: null, backgroundColor: null },
      },
      {
        className: ".JS-CustomFieldTextContent-Label",
        label: "The label (description) for the 'text' custom field",
        values: { color: null },
      },
      {
        className: ".JS-CustomFieldEmailContent-Input",
        label: "The 'email' custom field",
        values: { color: null, backgroundColor: null },
      },
      {
        className: ".JS-CustomFields-NumpadInput-Label",
        label: "The label for the numpad input",
        values: { color: null },
      },
      {
        className: ".JS-OptionItemOptional-Checkbox",
        label: "Checkbox unchecked",
        values: {
          backgroundColor: null,
          color: null,
        },
      },
      {
        className: ".JS-OptionItemOptional-Checkbox-checked",
        label: "Checkbox checked",
        values: {
          backgroundColor: null,
          color: null,
        },
      },
      {
        className: ".JS-OptionItemRadio-Radio",
        label: "Radio unchecked",
        values: {
          backgroundColor: null,
          color: null,
        },
      },
      {
        className: ".JS-OptionItemRadio-Radio-checked",
        label: "Radio checked",
        values: {
          backgroundColor: null,
          color: null,
        },
      },
      {
        className: ".JS-CustomFields-NumpadInput-Component",
        label: "The value of the numpad input (ie, 5382)",
        values: { color: null },
      },
      {
        className: ".JS-OrderPage-Title",
        label: "Title on order page",
        values: { ...commonSettings },
      },
      {
        className: ".JS-Vouchers-VoucherButton",
        label: "Add voucher button",
        values: { ...commonSettings },
      },
      {
        className: ".JS-currency-symbol-ArticleDetail",
        label: "Currency in articles",
        values: {
          color: null,
          display: null,
        },
      },
      {
        className: ".JS-currency-symbol-OrderPage-ArticleCard",
        label: "Currency symbol in an article on the orderpage",
        values: {
          display: null,
          color: null,
        },
      },
      {
        className: ".JS-currency-symbol-OrderPage-Subtotal",
        label: "Currency symbol for the subtotal on the order page",
        values: {
          display: null,
          color: null,
        },
      },
      {
        className: ".JS-currency-value-OrderPage-ArticleCard",
        label: "Currency value in an article on the order page",
        values: {
          color: null,
          display: null,
        },
      },
      {
        className: ".JS-currency-value-OrderPage-Subtotal",
        label: "Currency value for the subtotal on the order page",
        values: {
          color: null,
          display: null,
        },
      },
      {
        className: ".JS-currency-symbol-Menu",
        label: "Currency in menu",
        values: {
          color: null,
          display: null,
        },
      },
      {
        className: ".JS-currency-symbol-CheckoutPage-Price",
        label: "Currency symbol for the total on the checkout page",
        values: {
          color: null,
          display: null,
        },
      },
      {
        className: ".JS-currency-value-CheckoutPage-Price",
        label: "Currency value for the total on the checkout page",
        values: {
          color: null,
          display: null,
        },
      },
      {
        className: ".JS-currency-value-Checkout",
        label: "Currency value for checkout",
        values: {
          color: null,
          display: null,
        },
      },
      {
        className: ".JS-currency-value-ArticleContent-price",
        label: "Currency value for the ArticleContent component",
        values: {
          color: null,
          display: null,
        },
      },
      {
        className: ".JS-currency-symbol-ArticleContent-price",
        label: "Currency symbol for the ArticleContent component",
        values: {
          color: null,
          display: null,
        },
      },
      {
        className: ".JS-currency-symbol-Checkout",
        label: "Currency in checkout/order",
        values: {
          display: null,
          color: null,
        },
      },
      {
        className: ".JS-ArticlegroupContent-Root",
        label: "Content",
        values: { backgroundColor: null, color: null },
      },
      {
        className: ".JS-ArticleContent-Price",
        label: "Article Price Text",
        values: { ...commonSettings, ...fontSettings },
      },
      {
        className: ".JS-ArticleContent-LocalPrice",
        label: "From price label",
        values: { ...commonSettings },
      },
      {
        className: ".JS-ArticleContent-Price-IsCampaign",
        label: "Is campaign price label",
        values: { ...commonSettings, ...fontSettings },
      },
      {
        className: ".JS-ArticleCounter-Count",
        label: "Article Counter",
        values: { ...commonSettings, ...fontSettings },
      },
      {
        className: ".JS-ArticleContent-Name",
        label: "Article Title",
        values: {
          alignSelf: null,
          ...commonSettings,
          ...fontSettings,
        },
      },
      {
        className: ".JS-ArticleContent-PriceWrapper",
        label: "Article Price",
        values: {
          alignSelf: null,
          ...commonSettings,
        },
      },
      {
        className: ".JS-ArticleDialog-Price",
        label: "Article Price",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OrderArticleContent-Price",
        label: "Article Price",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-SelectedPackaging-Title",
        label: "Packaging title",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-SelectedPackaging-Option",
        label: "Packaging option",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OrderArticleContent-Title",
        label: "Article Title",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-ArticleDialog-ExtraPrice",
        label: "Extra articles",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-ArticleContent-Description",
        label: "Article Description",
        values: { ...commonSettings, width: null, height: null, WebkitLineClamp: null },
      },
      {
        className: ".JS-ArticleContent-ImageWrapper",
        label: "Article Image Wrapper",
        values: { ...commonSettings, width: null },
      },
      {
        className: ".JS-OrderArticleSelectorPage-Image",
        label: "Article image on product details page",
        values: { height: null },
      },
      {
        className: ".JS-OrderArticleSelectorPage-Warning",
        label: "Warning message",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OrderArticleSelectorPage-root",
        label: "Article Details Page",
        values: { backgroundColor: null },
      },
      {
        className: ".JS-ArticleDialog-Name",
        label: "Article Details Page Title",
        values: { ...commonSettings },
      },
      {
        className: ".JS-OrderArticleSelectorPage-ArticleTraits",
        label: "Article Details Page Traits",
        values: { display: null },
      },
      {
        className: ".JS-CampaignMenuItem-Root",
        label: "Campaign menu item root",
        values: { ...commonSettings, height: null },
      },
      {
        className: ".JS-CampaignMenuItem-Button",
        label: "Campaign menu item button",
        values: { ...commonSettings, height: null },
      },
      {
        className: ".JS-CampaignMenuItem-Stack",
        label: "Campaign menu item stack",
        values: { ...commonSettings, height: null },
      },
      {
        className: ".JS-CampaignMenuItem-Image",
        label: "Campaign menu item image",
        values: { ...commonSettings, height: null },
      },
      {
        className: ".JS-CampaignMenuItem-Title",
        label: "Campaign menu item title",
        values: { ...commonSettings, height: null },
      },
      {
        className: ".JS-ArticleDialog-Description",
        label: "Article Details Page - Article Description",
        values: {
          ...commonSettings,
          opacity: null,
        },
      },
      {
        className: ".JS-OrderArticleContent-ChangeOrderButton",
        label: "Order item - Change Button",
        values: { backgroundColor: null, color: null, borderColor: null, fontFamily: null, fontSize: null },
      },
      {
        className: ".JS-OrderArticleContent-PlusButton",
        label: "Order item, +1 button",
        values: { color: null },
      },
      {
        className: ".JS-OrderArticleContent-MinusButton",
        label: "Order item, -1 (and delete) button",
        values: { color: null },
      },
      {
        className: ".JS-OrderArticleContent-Option",
        label: "The option chips belonging to a product",
        values: {
          ...buttonSettings,
          margin: null,
          padding: null,
          border: null,
        },
      },
      {
        className: ".JS-ArticleContent-NotAvailable",
        label: "Overlay used when item is not available",
        values: { opacity: null, backgroundColor: null },
      },
      {
        className: ".JS-ArticleContent-NotAvailable-Text",
        label: "Text shown when item is not available",
        values: { ...commonSettings, display: null },
      },
      {
        className: ".JS-ArticleContent-OutOfStock",
        label: "Overlay used when item is out of stock",
        values: { opacity: null, backgroundColor: null },
      },
      {
        className: ".JS-NextButton",
        label: "Voeg toe button",
        values: {
          ...buttonSettings,
          margin: null,
          padding: null,
          border: null,
          borderRadius: null,
          borderColor: null,
          ...fontSettings,
        },
      },
      {
        className: ".JS-OptionOrderGroups-PreviousButton",
        label: "Voeg toe button",
        values: {
          ...buttonSettings,
          margin: null,
          padding: null,
          border: null,
          borderRadius: null,
          borderColor: null,
          ...fontSettings,
        },
      },
      {
        className: ".JS-ArticleContent-OutOfStock-Text",
        label: "Text shown when item is out of stock",
        values: { ...commonSettings, display: null },
      },
    ]);

    components.push({
      className: ".JS-ArticlegroupContent-Description",
      label: "Articlegroup Content Description",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-MenuFilter-Switch",
      label: ".JS-MenuFilter-Switch",
      values: {
        ...commonSettings,
        transform: null,
      },
    });
    components.push({
      className: ".JS-DisplayAIUpsellOrderPage-Title",
      label: ".JS-DisplayAIUpsellOrderPage-Title",
      values: {
        ...fontSettings,
      },
    });
    components.push({
      className: ".JS-MenuFilter-Switch-not-checked",
      label: ".JS-MenuFilter-Switch-not-checked",
      values: {
        ...commonSettings,
        transform: null,
      },
    });
    components.push({
      className: ".JS-MenuFilter-Switch-checked",
      label: ".JS-MenuFilter-Switch-checked",
      values: {
        ...commonSettings,
        transform: null,
      },
    });
    components.push({
      className: ".JS-Supergroups-Indicator",
      label: "Supergroup indicator",
      values: {
        backgroundColor: null,
        margin: null,
      },
    });
    components.push({
      className: ".JS-ArticleSuggestionPage-Root",
      label: "Container for article suggestion page",
      values: {
        backgroundColor: null,
      },
    });
    components.push({
      className: ".JS-ArticleSuggestionPage-Title",
      label: "Upsell Title",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-ArticleSuggestionPage-Text",
      label: "Upsell subtitle",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-PackagingFee-Title",
      label: "Packaging Fee Title",
      values: {
        ...fontSettings,
      },
    });
    components.push({
      className: ".JS-PackagingFee-Amount",
      label: "Packaging Fee Amount",
      values: {
        ...fontSettings,
      },
    });
    components.push({
      className: ".JS-PackagingFee-Wrapper",
      label: "Packaging Fee Wrapper",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-ArticleSuggestionItem-Paper",
      label: ".JS-ArticleSuggestionItem-Paper",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-OptionGroupContent-Name",
      label: "Name",
      values: {
        ...fontSettings,
      },
    });
    components.push({
      className: ".JS-ArticleSuggestionItem-Root",
      label: "Root",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-ArticleSuggestionItem-Image",
      label: "Image",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-ArticleSuggestionItem-Name",
      label: "Name",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-ArticleSuggestionItem-Price",
      label: "Price",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-OptionGroupContent-Explanation",
      label: "Explanation",
      values: {
        ...fontSettings,
      },
    });
    components.push({
      className: ".JS-OptionGroupContent-Description",
      label: "Description",
      values: {
        ...fontSettings,
      },
    });
    components.push({
      className: ".JS-ArticleContent-Paper",
      label: "Container for an article in the menu",
      values: {
        boxShadow: null,
        backgroundColor: null,
        borderRadius: null,
      },
    });
    components.push({
      className: ".JS-ArticleContent-MenuTags",
      label: "Container MenuTags",
      values: {
        display: null,
        boxShadow: null,
        backgroundColor: null,
        borderRadius: null,
      },
    });
    components.push({
      className: ".JS-MenuFilterDialog-AllergiesTitle",
      label: "My allergies title",
      values: {
        ...commonSettings,
      },
    });
    components.push({
      className: ".JS-ArticlegroupContent-HeaderWrapper",
      label: "Wrapper for the menu image as well as the header text",
      values: {
        display: null,
        margin: null,
        padding: null,
        alignItems: null,
        justifyContent: null,
      },
    });
    components.push({
      className: ".JS-MenuFilterDialog-PreferencesTitle",
      label: "My preferences title",
      values: {
        ...commonSettings,
      },
    });
    components = components.concat([
      {
        className: ".JS-OrderArticleContent-Option-TextName",
        label: "Name(s) of the option(s) belonging to an order item on the order page",
        values: {
          ...commonSettings,
        },
      },
      {
        className: ".JS-OrderArticleContent-Option-Amount",
        label: "Amount op the options",
        values: {
          ...commonSettings,
        },
      },
    ]);

    return components;
  }, [shoppingCartButtonType, useAccountServer_input, useAccountServer]);
}
